const ESTIMATED_FLOOR_LEVELS_GEOCOMM = 'ESTIMATED_FLOOR_LEVELS_GEOCOMM';

export const externalLinks = {
  [ESTIMATED_FLOOR_LEVELS_GEOCOMM]: {
    title: 'Vertical Location Content.',
    url: 'https://rapidsos.com/geocomm-and-rapidsos-z-axis-data',
  },
};
